const UPDATES = [
  { date: '2026-07-19', title: '网站服务器全面升级，黑料视频在线观看速度提升50%', tag: '公告', tagColor: 'bg-accent-500 text-background-50' },
  { date: '2026-07-18', title: '新增"综艺内幕"专题板块，海量综艺黑料视频已上线', tag: '上新', tagColor: 'bg-primary-500 text-background-50' },
  { date: '2026-07-17', title: '黑料视频App iOS版本更新至v3.2.0，支持画中画播放', tag: '更新', tagColor: 'bg-secondary-500 text-background-50' },
  { date: '2026-07-15', title: '热门话题"网红直播翻车"合集播放量突破1000万', tag: '里程碑', tagColor: 'bg-accent-500 text-background-50' },
  { date: '2026-07-12', title: '平台注册用户突破500万，感谢每一位用户的支持与信任', tag: '公告', tagColor: 'bg-primary-500 text-background-50' },
  { date: '2026-07-10', title: '黑料视频下载功能优化，支持批量下载和断点续传', tag: '更新', tagColor: 'bg-secondary-500 text-background-50' },
  { date: '2026-07-08', title: '新增"体育圈""音乐圈"两大内容板块，内容覆盖更全面', tag: '上新', tagColor: 'bg-primary-500 text-background-50' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">最新动态</h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">黑料视频平台最新公告、功能更新与里程碑事件一览</p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-5 top-0 bottom-0 w-0.5 bg-background-200"></div>

          <div className="space-y-6">
            {UPDATES.map((item, idx) => (
              <div key={idx} className="relative pl-10 md:pl-12">
                <div className={`absolute left-2.5 md:left-3.5 top-1.5 w-3 h-3 rounded-full border-2 border-background-50 ${
                  idx === 0 ? 'bg-accent-500' : 'bg-primary-400'
                }`}></div>

                <div className="bg-background-100 border border-background-200/70 rounded-xl p-4 md:p-5">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium w-fit whitespace-nowrap ${item.tagColor}`}>{item.tag}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900">{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}